import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const checks = ['PDF optimizado para móvil (consulta en el taller)', 'Formato imprimible en A4', 'Acceso de por vida a futuras actualizaciones'];
export function InstantAccess() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-125" data-mp="34bsewfi5vjgw">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-126" data-mp="34f6fpjb6fkm8">
        <SectionTag icon="📦" data-id="element-127" data-mp="30cryt4r2iuxl">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-128" data-mp="2vjyu2gvlnmli">
          Todo se descarga en tu correo al instante.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-129" data-mp="2lmcd7ouqpkyw">
          Material profesional descargable al instante, sin esperar envíos.
        </p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-130" data-mp="2gmq1xkyh2esq">
          {checks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-ink" data-id="element-131" data-mp="2vr0uriu738fl">
              <CheckIcon size={16} className="text-success" data-id="element-132" data-mp="30pc5rww87oze" />
              {check}
            </div>)}
        </m.div>
      </div>
    </section>;
}